// src/componants/common/FeatureGate.js
import { useFeatureFlags } from "../../context/FeatureFlagsContext";
import { isFeatureAccessible } from "../../utils/featureVisibility";

/**
 * Route-level guard for the activeId-based navigation in Main.js.
 *
 * Renders `children` only when `feature` is accessible for the active
 * brand (fail-open: unknown feature key or missing flags => allowed).
 * Otherwise renders a fixed "feature disabled" notice, reusing the
 * existing `.ess-placeholder-box` styling already used elsewhere in
 * Main.js for empty/unavailable content — no new CSS, no changes to
 * the guarded screen component itself.
 *
 * Usage: {activeId === "attendance" && (
 *   <FeatureGate feature="attendance"><RemoteAttendance /></FeatureGate>
 * )}
 */
function FeatureGate({ feature, children }) {
  const flags = useFeatureFlags();

  if (isFeatureAccessible(flags, feature)) {
    return children;
  }

  return (
    <div className="ess-placeholder-box" role="status">
      هذه الميزة غير مفعلة لهذه الشركة
    </div>
  );
}

export default FeatureGate;
